<template>
  <div
    id="giftgiver-instruction"
    class="question"
  >
    <h1 class="header">
      {{ $t('gift_giving_report.giftGivingReportInstruction.header') }}
    </h1>
    <h2
      v-if="giftGivingReportQuestions?.gift_giving_report_instruction?.label"
      class="header"
    >
      {{ giftGivingReportQuestions?.gift_giving_report_instruction?.label }}
    </h2>
    <div class="content">
      <p
        v-for="(text, index) in giftGivingReportQuestions.gift_giving_report_instruction.text"
        :key="index"
        class="mb-1"
        v-html="text"
      />
    </div>
    <v-divider class="my-4" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'GiftGivingReportInstruction',
    computed: {
        ...mapGetters('giftGivingReport', ['giftGivingReportQuestions']),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        }
    }
};
</script>

<style scoped></style>
